import React from "react";
import { TableInput, ImgInput } from "components/common/input";
import { CaseImgInput } from "./caseImgInput";
import { CaseDropdown } from "./caseDropdown";
import type { ICasesDetail } from "service/interface/cases";
import { EnumCasesCategory } from "service/constant/casesContant";
import moment from "moment";

interface Props {
  data: ICasesDetail;
  setData: React.Dispatch<React.SetStateAction<ICasesDetail>>;
}

export function CaseInfoTable({ data, setData }: Props) {
  const handleTypeDropdown = (id: string) => {
    setData((prev) => ({
      ...prev,
      category: id,
    }));
  };

  const handleTitleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      title: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          사례 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            카테고리
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <CaseDropdown
              menuList={[
                {
                  id: "memorialPark",
                  name: "추모공원",
                },
                {
                  id: "funeral",
                  name: "이장∙개장",
                },
                {
                  id: "tombConstruction",
                  name: "묘 조성",
                },
                {
                  id: "landClearing",
                  name: "벌초 대행",
                },
              ]}
              label="카테고리"
              selectMenu={EnumCasesCategory[data.category]}
              onClick={handleTypeDropdown}
            />
          </div>
        </div>
        {data.createdAt && (
          <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
            <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
              생성일
            </div>
            <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
              {moment(data.createdAt).format("YYYY-MM-DD")}
            </div>
          </div>
        )}
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            제목
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.title}
              onChange={handleTitleInput}
              placeholder="제목을 입력해 주세요"
            />
          </div>
        </div>
        <div className="flex h-[272px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-center text-M3 text-gray-4">
            전 사진
            <br />
            (최대 1장)
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <ImgInput data={data} setData={setData} name="beforeImgSrc" />
          </div>
        </div>
        <div className="flex h-[272px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-center text-M3 text-gray-4">
            후 사진
            <br />
            (최대 1장)
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <ImgInput data={data} setData={setData} name="afterImgSrc" />
          </div>
        </div>
        <div className="flex h-fit w-full border-b-[1px] border-b-gray-1">
          <div className="flex w-[148px] items-center justify-center bg-[#f4f4f4] text-center text-M3 text-gray-4">
            기타 사진
            <br />
            (최대 5장)
          </div>
          <div className="flex h-full w-[787px] flex-col items-center gap-[12px] px-[12px] py-[16px] text-M3 text-gray-5">
            <div className="flex h-full w-full cursor-pointer flex-col items-center justify-center gap-[14px] rounded-[8px] border-[1px] border-dashed border-gray-2 bg-[#fafafa] py-[16px]">
              {[...Array(5)].map((_, idx) => (
                <CaseImgInput
                  imgData={data.Images[idx]}
                  data={data}
                  setData={setData}
                  idx={idx}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
